import InsightsIcon from '@mui/icons-material/Insights'
import { Modal } from '@mui/material'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import React, { useState } from 'react'
import '../../../scss/button.scss'
import { CustomTablePagination } from '../../CustomTablePagination'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: '-3px -3px 7px #97949473, 2px 2px 7px rgb(137, 138, 138)',
  pt: 2,
  px: 4,
  pb: 3
}
const mobileStyle = {
  width: '90%',
  maxWidth: '90vw' // Adjust the maximum width for smaller screens
}

const PopupEmulatorHistoryTable = ({ data, showToast }) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(3)
  const [historyRowSelected, setHistoryRowSelected] = useState(false)
  const [showAdditionalDialog, setShowAdditionalDialog] = useState(false)

  const handleShowAdditionalDialog = () => {
    setShowAdditionalDialog(true)
  }

  const handleCloseAdditionalDialog = () => {
    setShowAdditionalDialog(false)
  }

  const handleActionButtonClick = async (row) => {
    setHistoryRowSelected(row)
    handleShowAdditionalDialog(true)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  // const emptyRows =
  //   rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

  return (
    <div style={{ height: '50vh', overflow: 'auto' }}>
      {/* Additional Dialog */}
      {showAdditionalDialog && historyRowSelected && (
        <Modal
          open={showAdditionalDialog}
          onClose={handleCloseAdditionalDialog}
          aria-labelledby="additional-modal-title"
          aria-describedby="additional-modal-description"
        >
          <Box
            sx={{
              ...style,
              ...mobileStyle,
              maxHeight: '90vh',
              overflowY: 'auto',
              padding: '16px',
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              scrollbarWidth: 'thin',
              scrollbarColor: '#2c6feb #ffffff'
            }}
          >
            {/* Display cancelDetails if cancelled */}
            {historyRowSelected.cancelDetails && (
              <div>
                <h4 style={{ wordBreak: 'break-word' }}>Cancelled:</h4>
                <ol style={{ maxHeight: '150px', overflowY: 'auto' }}>
                  <li style={{ wordBreak: 'break-word' }}>
                    Latitude: {historyRowSelected.cancelDetails.latitude} <br />
                    Longitude: {historyRowSelected.cancelDetails.longitude}
                    <br />
                    deleteTime: {historyRowSelected.cancelDetails.deleteTime}
                  </li>
                </ol>
              </div>
            )}
            {/* Display Trip Points */}
            <div>
              <h4>Route:</h4>
              <ol
                style={{
                  maxHeight: '150px',
                  overflowY: 'auto',
                  scrollbarWidth: 'thin',
                  scrollbarColor: '#2c6feb #ffffff'
                }}
                className="custom-scrollbar"
              >
                {historyRowSelected.tripPoints.map((point, index) => (
                  <li key={index}>
                    Latitude: {point.lat}
                    <br />
                    Longitude: {point.lng}
                    <br />
                    Bearing:{point.bearing}
                    <br />
                    Distance: {point.distance}
                  </li>
                ))}
              </ol>
            </div>
            <h3>Rests</h3>

            <div>
              <ul
                style={{
                  maxHeight: '150px',
                  overflowY: 'auto',
                  scrollbarWidth: 'thin',
                  scrollbarColor: '#2c6feb #ffffff'
                }}
                className="custom-scrollbar"
              >
                {historyRowSelected.stops.length > 0 ? (
                  historyRowSelected.stops.map((stop, index) => {
                    const address =
                      stop?.address?.length > 0
                        ? stop.address
                          .map((item) => item?.long_name)
                          .filter(Boolean)
                          .join(', ')
                        : null

                    const gasStationAddress =
                      stop?.gasStation?.length > 0
                        ? stop.gasStation
                          .map((item) => item?.long_name)
                          .filter(Boolean)
                          .join(', ')
                        : null

                    return (
                      <li key={index} style={{ wordBreak: 'break-word' }}>
                        {stop.lat && <>Latitude: {stop.lat}, </>}
                        {stop.lng && <>Longitude: {stop.lng}, </>}
                        {stop.bearing && <>Bearing: {stop.bearing}, </>}
                        {stop.distance && <>Distance: {stop.distance}, </>}
                        {address && <>Address: {address}, </>}
                        {gasStationAddress && (
                          <>Gas Station Address: {gasStationAddress}</>
                        )}

                        {stop?.tripPoints?.length > 0 && (
                          <>
                            <h4>Rest Route:</h4>
                            <ol
                              style={{
                                maxHeight: '150px',
                                overflowY: 'auto',
                                scrollbarWidth: 'thin',
                                scrollbarColor: '#2c6feb #ffffff'
                              }}
                              className="custom-scrollbar"
                            >
                              {stop.tripPoints.map((point, idx) => (
                                <li key={idx}>
                                  {point.lat && (
                                    <>
                                      Lat: {point.lat} <br />
                                    </>
                                  )}
                                  {point.lng && (
                                    <>
                                      Lng: {point.lng} <br />
                                    </>
                                  )}
                                  {point.bearing && (
                                    <>
                                      Bearing: {point.bearing} <br />
                                    </>
                                  )}
                                  {point.distance && (
                                    <>
                                      Distance: {point.distance} <br />
                                    </>
                                  )}
                                </li>
                              ))}
                            </ol>
                          </>
                        )}
                      </li>
                    )
                  })
                ) : (
                  <p>No Rest Stops Available</p>
                )}
              </ul>
            </div>

            <h3>Breaks</h3>
            {/* Display Breaks Points Here */}
            <div>
              <ul
                style={{
                  maxHeight: '150px',
                  overflowY: 'auto',
                  scrollbarWidth: 'thin',
                  scrollbarColor: '#2c6feb #ffffff'
                }}
                className="custom-scrollbar"
              >
                <h4>Breaks Route:</h4>
                <ol
                  style={{
                    maxHeight: '150px',
                    overflowY: 'auto',
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#2c6feb #ffffff'
                  }}
                  className="custom-scrollbar"
                >
                  {historyRowSelected?.breakPoints?.map((breaks, index) => (
                    <li key={`break-item-${index}`}>
                      Lat: {Number(breaks?.location?.lat)}
                      <br />
                      Lng: {Number(breaks?.location?.lng)}
                      <br />
                      Bearing: {breaks?.bearing}
                      <br />
                      Distance: {breaks?.distance}
                    </li>
                  ))}
                </ol>
              </ul>
            </div>
            <button
              style={{
                background: 'rgba(255, 77, 0, 1)',
                color: 'white',
                fontWeight: 'bold',
                padding: '10px 20px',
                borderRadius: '8px',
                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                transition: 'all 0.3s ease-in-out',
                border: 'none',
                cursor: 'pointer',
                display: 'block',
                marginLeft: '79vw',
                width: 'fit-content' // responsive width
              }}
              onClick={handleCloseAdditionalDialog}
              onMouseOver={(e) =>
                (e.target.style.background = 'rgb(230, 70, 0)')
              }
              onMouseOut={(e) =>
                (e.target.style.background = 'rgba(255, 77, 0, 1)')
              }
            >
              CLOSE
            </button>
          </Box>
        </Modal>
      )}

      {data.length !== 0 ? (
        <div
          className="tableBox"
          style={{
            backgroundColor: '#000000'
          }}
        >
          <table
            aria-label="custom pagination table"
            className="table table-borderless"
          >
            <thead
              style={
                {
                  // backgroundColor: '#000000', // Black background
                  // color: '#ffffff', // White text for contrast
                  // textAlign: 'left', // Center text alignment
                  // fontSize: '16px', // Increase font size for better readability
                  // fontWeight: 'light', // Make text bold
                  // padding: '12px', // Add padding for spacing
                  // borderBottom: 'none' // Removes the border line
                }
              }
            >
              <tr>
                <th
                  style={{
                    fontFamily: 'Inter',
                    fontSize: '16px',
                    fontWeight: '80',
                    letterSpacing: '0.5px'
                  }}
                >
                  FROM
                </th>
                <th
                  style={{
                    fontFamily: 'Inter',
                    fontSize: '16px',
                    fontWeight: '80',
                    letterSpacing: '0.5px'
                  }}
                >
                  TO
                </th>
                <th
                  style={{
                    fontFamily: 'Inter',
                    fontSize: '16px',
                    fontWeight: '80',
                    letterSpacing: '0.5px'
                  }}
                >
                  DISTANCE
                </th>
                <th
                  style={{
                    fontFamily: 'Inter',
                    fontSize: '16px',
                    fontWeight: '80',
                    letterSpacing: '0.5px'
                  }}
                >
                  TIME
                </th>
                <th
                  style={{
                    fontFamily: 'Inter',
                    fontSize: '16px',
                    fontWeight: '80',
                    letterSpacing: '0.5px'
                  }}
                >
                  ACTION
                </th>
              </tr>
            </thead>
            <tbody
              style={{
                fontFamily: 'Inter',
                fontSize: '16px'
              }}
            >
              {(rowsPerPage > 0
                ? data.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
                : data
              ).map((row) => {
                const fromAddress =
                  row?.fromAddress[0]?.long_name +
                    ', ' +
                    row?.fromAddress[1]?.long_name +
                    ', ' +
                    row?.fromAddress[2]?.long_name +
                    ', ' +
                    row?.fromAddress[3]?.long_name || 'N/A'
                const toAddress =
                  row?.toAddress[0]?.long_name +
                    ', ' +
                    row?.toAddress[1]?.long_name +
                    ', ' +
                    row?.toAddress[2]?.long_name +
                    ' ,' +
                    row?.toAddress[3]?.long_name || 'N/A'

                const distance = row.distance
                  ? row.distance.toFixed(2) + ' Miles'
                  : 'N/A'
                const time = row.distance
                  ? ((row.distance / row.velocity) * 60).toFixed(2)
                  : null

                const hours = time ? Math.floor(time / 60) : null
                const minutes = time ? (time % 60).toFixed() : null

                const formattedTime =
                  time && !isNaN(hours) && !isNaN(minutes)
                    ? `${hours} hour${hours !== 1 ? 's' : ''}, ${minutes} minute${
                        minutes !== '1' ? 's' : ''
                      }`
                    : 'N/A'

                return (
                  <tr
                    key={row.id || 'N/A'}
                    style={{
                      fontFamily: 'Poppins, sans-serif',
                      fontWeight: '100',
                      overflow: 'scroll',
                      wordSpacing: '-4px' // Add spacing between words
                    }}
                  >
                    <td>{fromAddress || 'N/A'}</td>
                    <td>{toAddress || 'N/A'}</td>
                    <td>{distance}</td>
                    <td>{formattedTime}</td>
                    <td>
                      <IconButton
                        style={{
                          height: 'auto',
                          width: '40px',
                          margin: '2px',
                          color: '#ffffff',
                          backgroundColor: '#666666'
                        }}
                        aria-label="delete"
                        text
                        onClick={() => handleActionButtonClick(row)}
                      >
                        <InsightsIcon />
                      </IconButton>
                    </td>
                  </tr>
                )
              })}
              {/* {emptyRows > 0 && (
            <tr style={{ height: 34 * emptyRows }}>
              <td colSpan={5} />
            </tr>
          )} */}
            </tbody>
            <tfoot>
              <tr style={{ position: 'fixed', bottom: 0, right: 0 }}>
                <CustomTablePagination
                  rowsPerPageOptions={[3, 5, 10, { label: 'All', value: -1 }]}
                  colSpan={5}
                  count={data.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  style={{ overflow: 'hidden' }}
                />
              </tr>
            </tfoot>
          </table>
        </div>
      ) : (
        <div style={{ display: 'flex' }}>
          <p style={{ margin: '15px 500px 15px auto' }}>No records found!</p>
        </div>
      )}
    </div>
  )
}

export default PopupEmulatorHistoryTable
